import { useTranslation } from 'react-i18next'
import { Spinner } from 'baseui/spinner'
import RetryConfirmationChecks from '../RetryConfirmationChecks'
import { RetryProgress } from '../../styled-components'

interface RetryModalBodyProps {
  isRetrying: boolean
  confirmationRequired: boolean
  emailChecked: boolean
  spamChecked: boolean
  onEmailChange: (checked: boolean) => void
  onSpamChange: (checked: boolean) => void
}

const RetryModalBody = ({
  isRetrying,
  confirmationRequired,
  emailChecked,
  spamChecked,
  onEmailChange,
  onSpamChange,
}: RetryModalBodyProps) => {
  const { t } = useTranslation()

  if (isRetrying) {
    return (
      <RetryProgress>
        <Spinner />
        <div>{t('additionalSales:common.retry_in_progress')}</div>
      </RetryProgress>
    )
  }

  return (
    <RetryConfirmationChecks
      hidden={!confirmationRequired}
      emailChecked={emailChecked}
      spamChecked={spamChecked}
      onEmailChange={onEmailChange}
      onSpamChange={onSpamChange}
    />
  )
}

export default RetryModalBody
